<template>
  <div class="bg-white">
    <div class="min-h-0 search--list overflow-y-auto overflow-x px-2">
      <SearchMainSection ref="searchMainSection" />
      <div class="flex">
        <button
          @click="showMoreOptions"
          class="focus:outline-none text-zt-md ml-auto text-zt-secondary-200"
          data-vs-button="show-options"
        >
          <div class="flex items-center">
            <span class="font-medium">
              {{ $t('message.searchComponent.searchAdvance') }}
            </span>
            <zt-icon class="pl-1" :class="{ 'r180' : advanceOptions}" name="arrow-down" />
          </div>
        </button>
      </div>
      <div v-show="advanceOptions">
        <EmployeeSection ref="employeeSection" />
        <SearchDocumentSection ref="searchDocumentSection" />
        <SearchEformSection ref="searchEformSection" />
      </div>
    </div>
    <div class="footer flex justify-end py-8 px-8">
      <zt-button
          text
          class="button-cancel mr-4 font-medium"
          @click="cleanFilters()"
          data-vs-button="clean-filters"
        >
          {{ $t('message.searchComponent.cleanFilters') }}
        </zt-button>
      <div class="search--btn">
        <zt-button @click="searchDocuments(true)"
          :loader= "store.isLoading"
          loaderTxt="Cargando..."
          data-vs-button="search-documents"
          >
          {{ $t('message.searchComponent.search') }}
        </zt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import SearchMainSection from './SearchMainSection.vue'
import EmployeeSection from './EmployeeSection/index.vue'
import SearchDocumentSection from './SearchDocumentSection.vue'
import SearchEformSection from './SearchEformSection.vue'
import Search from '@/apiClient/Search'
import { isEqual } from 'lodash'

export default {
  name: 'SearchList',
  components: {
    SearchMainSection,
    EmployeeSection,
    SearchDocumentSection,
    SearchEformSection
  },
  inject: [
    'setHaveResults',
    'setIsLoading',
    'setResultsEforms',
    'setDocuments',
    'setInitialStatus',
    'setOrderBy',
    'setOrderType',
    'setPagination',
    'setTotal',
    'setPageCount',
    'setFilters',
    'setHistory',
    'store',
    'existHistoryProperty',
    'clearFilters'
  ],
  data() {
    return {
      queryParamsCache: {},
      searchConfig: new Search(),
      advanceOptions: false
    }
  },
  computed: {
    queryParams() {
      return {
        orderBy: this.store.orderBy,
        orderType: this.store.orderType,
        pagination: this.store.pagination,
      }
    },
  },
  watch: {
    queryParams() {
      if (isEqual(this.queryParams, this.queryParamsCache)) return
      this.searchDocuments()
    },
  },
  methods: {
    resetParams() {
      this.setOrderBy('id')
      this.setOrderType('desc')
      this.setPagination({
        rows: 20,
        page: 1,
      })
    },
    async searchDocuments(clicked) {
      window.dataLayer.push({
        event: 'zt-gtm-documents-search-search',
        action: 'click',
        value: 500,
      })

      this.setIsLoading(true)

      if (clicked) {
        this.resetParams()
      }

      const { filters, pagination, orderBy, orderType, history } = this.store
      const params = `pagination=${pagination.rows},${pagination.page},0&orderBy=${orderBy}&orderType=${orderType}`

      this.queryParamsCache =  { pagination, orderBy, orderType }

      this.$store.dispatch('setSearchDocumentRRHH', {
        documentSearch: {
          params: history.params || {},
          pagination, orderBy, orderType
        }
      })

      const [responseSearch, responseEforms] = await Promise.allSettled([
        this.searchConfig.SearchDocuments(filters, params),
        this.searchConfig.ResultEforms(filters),
      ])

      if (responseSearch.status === 'rejected') {
        this.setIsLoading(false)
        this.setHaveResults(false)
        this.setInitialStatus(false)
        this.setDocuments([])
        return
      }

      const {
        value: {
          data: { data, pagination: responsePagination },
        },
      } = responseSearch

      this.setIsLoading(false)
      this.setHaveResults(true)
      this.setInitialStatus(false)
      this.setDocuments(data)
      this.setTotal(responsePagination.total)
      this.setPageCount(responsePagination.pageCount)
      window.history.replaceState(null, '', window.location.pathname)

      if (responseEforms.status === 'rejected') {
        return this.setResultsEforms([])
      }

      const {
        value: {
          data: { data: filtersEformsData },
        },
      } = responseEforms

      this.setResultsEforms(filtersEformsData)
    },
    showMoreOptions() {
      this.advanceOptions = !this.advanceOptions
    },
    cleanFilters(){
      this.$refs.searchMainSection.cleanFilters()
      this.$refs.employeeSection.cleanFilters()
      this.$refs.searchDocumentSection.clearDateInputs()
      this.$refs.searchDocumentSection.cleanFilters()
      this.$refs.searchEformSection.clearDateInputs()
      this.$refs.searchEformSection.cleanFilters()
      this.setInitialStatus(true)
      this.setHistory({})
      this.clearFilters()
      this.$store.dispatch('setSearchDocumentRRHH', { documentSearch: {} })
    }
  }
}
</script>
<style scoped lang="scss">
.search--list {
  height: calc(100vh - 74px - 70px - 60px - 58px);
}

.search--btn {
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.1);
}

.footer {
  background: #E5E5E5;
  font-size: 14px;
  .text-zt-dark-b6 {
    color: #B6B6B6!important;
  }
  ::v-deep {
    .button-cancel {
      color: #707070!important;
      background: transparent!important;
    }
  }
}
::v-deep .multiselect__option--selected,
::v-deep .multiselect__option--highlight {
  background-color: #eae8f4 !important;
  color: #707070;
  font-weight: normal;
}
.r180 {
  transform: rotate(180deg);
}
</style>
